import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./plugins/i18n";
import dayjs from "./plugins/dayjs";
import vuetify from "./plugins/vuetify";
import apolloProvider from "./plugins/apollo";
import "@babel/polyfill";

Vue.config.productionTip = false;

new Vue({
  i18n,
  router,
  store,
  vuetify,
  apolloProvider,
  dayjs,
  render: (h) => h(App),
}).$mount("#app");
